<!-- download -->
<div *ngIf="attached_file && typeFile">
  <mat-card fxFlex="50" fxFlex.lt-md="90">
    <mat-card-header>
      <mat-card-title>{{titleFile}} <i class="fa {{getPicto(attached_file)}}" aria-hidden="true"></i>&nbsp; {{attached_file.name}}</mat-card-title>
      <i class="material-icons" matTooltip="Enlever ce fichier" (click)="deletePJ(attached_file, typeFile)">delete_outline</i>
    </mat-card-header>

    <mat-card-content>
      <button (click)="onDownload($event, typeFile)"
              mat-raised-button matTooltip="Télécharger ce fichier">
        <mat-icon>file_download</mat-icon>
        Télécharger ce fichier
      </button>
      <app-file-preview [file]="attached_file"></app-file-preview>
    </mat-card-content>
  </mat-card>
</div>

<!-- upload -->
<div *ngIf="! attached_file && typeFile">
  <dar-piece-jointe-uploader fxFlex="50" fxFlex.lt-md="90"
                             [typeFile]="typeFile"
                             [placeHolder]="placeHolder"
                             [accept]="'.pdf,.png,.doc,.docx, .odt'"
                             [multiple]="false"
                             [maxFileSize]="5300000"
                             [displayModelFiles]="displayModelFiles"
                             (onSelected)="onSelectedPj($event)"
                             [connector]="uploaderConnector"
                             (onFinished)="handleFilesUploaded($event)"
                             (onError)="onError($event)">
  </dar-piece-jointe-uploader>
</div>
